import * as sites from '@/mocks/data/park/sites/list'

import { Machine } from '@/types/machines/machine'

export const machine1: Machine = {
    id: 88,
    name: 'Machine 1 usine Sodebo',
    site: sites.site1,
}
